import React, { useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate, useRoutes } from "react-router-dom";
import { useGetTargetList } from "../../hooks/useManagement";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { separate } from "../../utils/separate";
import Button from "../Button/Button";
import { DeleteTargetModal } from "../Dialog/DeleteTargetModal";
import { EditTargetModal } from "../Dialog/EditTargetModal";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";
import { TargetHollTableStyle } from "./TargetHollTableStyle";

const TargetHollTable = () => {
  const [Search, setSearch] = useState("");
  const [show, setShow] = useState({
    delete: false,
    edit: false,
  });
  const [targetId, setTargetId] = useState();
  const [targetObj, setTargetObj] = useState();
  const { data, isLoading } = useGetTargetList();
  const targets = data?.data?.sale_targets;
  const navigate = useNavigate();
  const TargetListHeaderTitle = [
    "ردیف",
    "تاریخ شروع",
    "تاریخ پایان",
    "تارگت",
    "تاریخ ایجاد تارگت",
  ];

  const items = targets
    ?.filter((target) => {
      if (Search === "") {
        return target;
      } else if (target.FromDate.includes(Search)) {
        return target;
      }
    })
    .map((target, index) => {
      return (
        <tr
          key={index}
          style={{ cursor: "pointer" }}
          onClick={() => navigate(`target/${target?.IdSaleTarget}`)}
        >
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {MiladiToShamsi(target?.FromDate)}
            </span>
          </td>

          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {MiladiToShamsi(target?.ToDate)}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {separate(target?.AmountSaleTarget)}
            </span>
          </td>

          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {MiladiToShamsi(target?.created_at)}
            </span>
          </td>
          {/* <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              <div className="d-flex">
                <Button
                  small="fit-content"
                  bgColor="#009ef7"
                  className="mx-1"
                  onclick={() => {
                    setShow({ ...show, edit: true });
                    setTargetObj(target);
                  }}
                >
                  <FaEdit size="16px" color="#fff" />
                </Button>
                <Button
                  small="fit-content"
                  bgColor="#f1416c"
                  className="mx-1"
                  onclick={() => {
                    setShow({ ...show, delete: true });
                    setTargetId(target?.IdSaleTarget);
                  }}
                >
                  <FaTrash size="16px" color="#fff" />
                </Button>
              </div>
            </span>
          </td> */}
        </tr>
      );
    });
  return (
    <TargetHollTableStyle>
      <Table
        className="mt-3"
        setSearch={setSearch}
        headerTitle={TargetListHeaderTitle}
        items={items ? items : <Loading />}
        title={`تارگت ها`}
      />
      <DeleteTargetModal
        show={show.delete}
        handleClose={() => setShow({ ...show, delete: false })}
        targetId={targetId}
      />
      <EditTargetModal
        show={show.edit}
        handleClose={() => setShow({ ...show, edit: false })}
        target={targetObj}
      />
    </TargetHollTableStyle>
  );
};

export default TargetHollTable;
